const routes = [
    {
        path: '/svc',
        name: 'Svc',
        meta: {
            layout: 'basic'
        },
        component: () => import(/* webpackChunkName: "main" */ '@/views/svc/svc-main.vue'),
        children: [
            {
                path: '/svc/seroi',
                name: 'Seroi',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/svc/seroi.vue'),
            },
            {
                path: '/svc/lbsc',
                name: 'Lbsc',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/svc/lbsc.vue'),
            },
            {
                path: '/svc/cprco',
                name: 'Cprco',
                meta: {
                    layout: 'basic'
                },
                component: () => import(/* webpackChunkName: "main" */ '@/views/svc/cprco.vue'),
            },
        ]
    },
]

export default routes;